function getRelatedDealsCarousel(data) {
  let url = '/browse/search/related?';
  let i = 0;
  for (const [k, v] of Object.entries(data)) {
    url += i === 0 ? `${k}=${v}` : `&${k}=${v}`;
    i++;
  }
  return fetch(url, { credentials: 'include' })
    .then(res => {
      if (res.status > 200) {
        return Promise.reject(res);
      } else {
        return Promise.resolve(res);
      }
    })
    .then(res => res.json());
}

module.exports = {
  getRelatedDealsCarousel,
};
